import React from 'react';

const Statistics: React.FC = () => {
  return null;
};

export default Statistics;